
export const renderTickFormatXAxis = (props: { domainValue: d3.AxisDomain; }) => {
  const { domainValue } = props;
  return domainValue.toString();
};
